class event {
  constructor() {
    this.clientObj = {}
    this.on = function (key, fn) {
      // 增加订阅者
      if (!this.clientObj[key]) {
        this.clientObj[key] = []
      }
      this.clientObj[key].push(fn)
      return {
        dispose: () => {
          this.off(key, fn)
        },
        fn,
        getFns: () => {
          return this.clientObj[key]
        }
      }
      // 订阅的消息添加进缓存列表
    }
    this.emit = function () {
      // 发布消息
      let key = Array.prototype.shift.call(arguments) //shift() 方法用于把数组的第一个元素从其中删除，并返回第一个元素的值。 这样写因为arguments不是一个真的数组 且又想对arguments这个类数组进行原数据操作
      // console.log(arguments);
      let fns = this.clientObj[key]
      if (!fns || fns === 0) {
        return false
      }
      for (let i = 0, fn; (fn = fns[i++]);) {
        // console.log(arguments, 'arguments');
        fn.apply(this, arguments) // (2) // arguments 是发布消息时带上的参数
        // fn(...arguments)
      }
    }
    this.off = function (key, fn) {
      let fns = this.clientObj[key]
      if (!fns) {
        // 如果 key 对应的消息没有被人订阅，则直接返回
        return false
      }
      if (!fn) {
        // 如果没有传入具体的回调函数，表示需要取消 key 对应消息的所有订阅
        fns && (fns.length = 0)
      } else {
        for (let l = fns.length - 1; l >= 0; l--) {
          // 反向遍历订阅的回调函数列表
          let _fn = fns[l]
          if (_fn === fn) {
            fns.splice(l, 1) // 删除订阅者的回调函数
          }
        }
      }
    }
  }
}
let _event = new event()
function installEvent(obj) {
  for (let i in _event) {
    obj[i] = _event[i]
  }
  return obj
}

export default installEvent
